var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { head } from '../../../../utils/helper/lodash_replacements';
export class AspectClassNames {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get classNamesAsArray() {
        const allClassNames = [];
        this.aspect.global.aspectActive.activeTraits.forEach((at) => {
            if (at.reg && at.reg.classNames) {
                const classNamesFromTrait = at.reg.classNames(at.context);
                allClassNames.push(...classNamesFromTrait);
            }
        });
        return allClassNames.filter((s) => s);
    }
    get classNamesAsString() {
        return this.classNamesAsArray.join(' ');
    }
    get textGrowChildGroupName() {
        return head(this.classNamesAsArray.filter((s) => s.startsWith('textGrowChild_')).map((s) => s.split('textGrowChild_')[1]));
    }
}
__decorate([
    computed
], AspectClassNames.prototype, "classNamesAsString", null);
